import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { useUpdateStoryContent } from '@coreStory/useCase';
import type { IStoryList } from '@coreStory/type';
import styles from './index.module.scss';

const { TextArea } = Input;

interface EditStoryModalProps {
  visible: boolean;
  onCancel: () => void;
  storyData: IStoryList;
  onSuccess?: () => void;
}

const EditStoryModal: React.FC<EditStoryModalProps> = ({
  visible,
  onCancel,
  storyData,
  onSuccess,
}) => {
  const [storyText, setStoryText] = useState(storyData?.StoryText || '');
  const { mutate: updateContent, isLoading } = useUpdateStoryContent();

  const handleSave = () => {
    if (storyData?.StoryID) {
      // Use StoryContentID if available, otherwise use VOrder as fallback
      const storyContentId = storyData.StoryContentID || storyData.VOrder;

      updateContent(
        {
          story_id: storyData.StoryID,
          story_content_id: storyContentId,
          story_text: storyText,
          vorder: storyData.VOrder,
        },
        {
          onSuccess: () => {
            onSuccess?.();
            onCancel();
          },
        },
      );
    }
  };

  const handleCancel = () => {
    setStoryText(storyData?.StoryText || '');
    onCancel();
  };

  return (
    <Modal
      title="Edit Story Content"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={isLoading}
          onClick={handleSave}>
          Save
        </Button>,
      ]}
      width={600}>
      <div className={styles.editContent}>
        <TextArea
          value={storyText}
          onChange={(e) => setStoryText(e.target.value)}
          rows={8}
          placeholder="Enter your story text here..."
          className={styles.textArea}
        />
      </div>
    </Modal>
  );
};

export default EditStoryModal;
